import { styled } from '@mui/material';

const Area = styled('div', { name: 'skarbonkaAreaName' })<{ area?: string }>(({ theme, area }) => ({
  [theme.breakpoints.up('sm')]: {
    margin: '16px 0',
    gridArea: area,
  },
}));

export default Area;
